import React from 'react';

type ProfileIconRoundedProps = {
  width?: string;
  height?: string;
  color?: string;
};

function ProfileIconRounded({
  width = '24',
  height = '25',
  color = '#6267AC',
}: ProfileIconRoundedProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 2.5C6.477 2.5 2 6.977 2 12.5C2 18.023 6.477 22.5 12 22.5C17.523 22.5 22 18.023 22 12.5C22 6.977 17.523 2.5 12 2.5Z'
        stroke={color}
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M4.271 18.846C4.271 18.846 6.5 16 12 16C17.5 16 19.73 18.846 19.73 18.846M12 12.5C12.7956 12.5 13.5587 12.1839 14.1213 11.6213C14.6839 11.0587 15 10.2956 15 9.5C15 8.70435 14.6839 7.94129 14.1213 7.37868C13.5587 6.81607 12.7956 6.5 12 6.5C11.2043 6.5 10.4413 6.81607 9.87868 7.37868C9.31607 7.94129 9 8.70435 9 9.5C9 10.2956 9.31607 11.0587 9.87868 11.6213C10.4413 12.1839 11.2043 12.5 12 12.5Z'
        stroke={color}
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}

export default ProfileIconRounded;
